import { UnitTypes } from './types';

const {
  GRIZZLY_SCREEN,
  CONVENTIONAL_SCREEN,
  LINEAR_MOTION_SCREEN,
  MULTISLOPE_SCREEN,
  FREEFALL_SCREEN_SF,
  FREEFALL_SCREEN_SS,
  KWATANI_SCREEN,
  BANANA_SCREEN,
  GENERIC_SCREEN,
} = UnitTypes;

export const minNbrOfDecks = {
  [GRIZZLY_SCREEN]: 1,
  [CONVENTIONAL_SCREEN]: 2,
  [LINEAR_MOTION_SCREEN]: 1,
  [MULTISLOPE_SCREEN]: 1,
  [FREEFALL_SCREEN_SF]: 3,
  [FREEFALL_SCREEN_SS]: 2,
  [KWATANI_SCREEN]: 1,
  [BANANA_SCREEN]: 1,
  [GENERIC_SCREEN]: 1,
};

export const maxNbrOfDecks = {
  [GRIZZLY_SCREEN]: 2,
  [CONVENTIONAL_SCREEN]: 4,
  [LINEAR_MOTION_SCREEN]: 3,
  [MULTISLOPE_SCREEN]: 2,
  [FREEFALL_SCREEN_SF]: 4,
  [FREEFALL_SCREEN_SS]: 3,
  [KWATANI_SCREEN]: 2,
  [BANANA_SCREEN]: 2,
  [GENERIC_SCREEN]: 4,
};
